<div class="modal fade modal-full-width modal-full-height" aria-hidden="true">
    <div class="modal-dialog modal-dialog-scrollable">
        <div class="modal-content" *ngIf="isOpen">
            <div class="modal-header">
                <h4 class="modal-title">
                    {{title}}
                </h4>
            </div>
            <div class="modal-body">
                <sgt-cliente-form
                    #form
                    [embedded]="true"
                    (afterCancel)="cancel()">
                </sgt-cliente-form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-light" (click)="cancel()">
                    Cancelar
                </button>
                <button type="button" class="btn btn-success" (click)="save()" id="btnSaveClienteFormModal">
                    Salvar
                </button>                
            </div>
        </div>
    </div>
</div>
